// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThemeCustomizer_themeCustomizer__PxPLJ {
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  background-color: transparent;
  /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05); */
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: var(--white-color);
  box-shadow: var(--shadow-md);
}

.ThemeCustomizer_themeCustomizer__PxPLJ h3 {
  margin-bottom: 20px;
  font-size: 1rem;
  color: var(--heading);
  text-align: center;
}

.ThemeCustomizer_themeGroup__X7Mzz {
  /* margin-bottom: 25px; */
  padding-bottom: 15px;
  /* border-bottom: 1px solid #f0f0f0; */
  width: 100%;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 8px;
  background-color: #e6edff;
  border: 1px solid #a3bdff;
}

/* .themeGroup:last-child {
  border-bottom: none;
} */

.ThemeCustomizer_themeOuterWrapper__YkH3g {
  /* border: 1px solid #ccc; */
  width: 100%;
  /* padding: 20px; */
  border-radius: 8px;
  /* margin: 20px auto; */
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
}
.ThemeCustomizer_themeinnerWrapper__O6ws5 {
  display: flex;
  gap: 16px;
  /* flex-wrap: wrap; */
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.ThemeCustomizer_themeGroup__X7Mzz h4 {
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #444;
}

.ThemeCustomizer_themeRow__EFayW {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.ThemeCustomizer_themeRow__EFayW label {
  font-size: 14px;
  font-weight: 500;
  color: #555;
  margin-right: 12px;
  flex: 1 1;
}

.ThemeCustomizer_themeRow__EFayW input[type="color"] {
  width: 48px;
  height: 32px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background: none;
  flex-shrink: 0;
}

.ThemeCustomizer_selectInput__aMWuS,
.ThemeCustomizer_textInput__o0wXU {
  width: 100%;
  padding: 10px 14px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #eff3ff;
  transition:
    border 0.2s ease,
    background-color 0.2s ease;
}

.ThemeCustomizer_selectInput__aMWuS:focus,
.ThemeCustomizer_textInput__o0wXU:focus {
  border-color: #7b61ff;
  background-color: #fff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(123, 97, 255, 0.15);
}

.ThemeCustomizer_errorText__SQtv- {
  color: #d93025;
  font-size: 13px;
  margin-top: 6px;
  font-weight: 500;
}

@media (max-width: 1086px) and (min-width: 768px) {
}

@media (max-width: 768px) and (min-width: 468px) {
  .ThemeCustomizer_themeOuterWrapper__YkH3g {
    padding: 0px;
    border: none;
  }
  .ThemeCustomizer_themeinnerWrapper__O6ws5 {
    display: block;
  }
  .ThemeCustomizer_themeinnerWrapper__O6ws5 > :first-child {
    margin-bottom: 20px;
  }
}

@media (max-width: 467px) {
  .ThemeCustomizer_themeOuterWrapper__YkH3g {
    padding: 0px;
    border: none;
  }
  .ThemeCustomizer_themeinnerWrapper__O6ws5 {
    display: block;
  }
  .ThemeCustomizer_themeinnerWrapper__O6ws5 > :first-child {
    margin-bottom: 20px;
  }
  .ThemeCustomizer_themeinnerWrapper__O6ws5 > :last-child {
    margin-top: 20px;
  }
  .ThemeCustomizer_themeCustomizer__PxPLJ,
  .ThemeCustomizer_themeGroup__X7Mzz {
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/NewCreateAppF/ThemeCustomizer.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,gDAAgD;EAChD,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,sCAAsC;EACtC,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,4BAA4B;EAC5B,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB;;8BAE4B;AAC9B;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;AACA;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,aAAa;EACf;AACF","sourcesContent":[".themeCustomizer {\n  margin: 20px auto;\n  padding: 20px;\n  border: 1px solid #e2e2e2;\n  border-radius: 6px;\n  background-color: transparent;\n  /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05); */\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background: var(--white-color);\n  box-shadow: var(--shadow-md);\n}\n\n.themeCustomizer h3 {\n  margin-bottom: 20px;\n  font-size: 1rem;\n  color: var(--heading);\n  text-align: center;\n}\n\n.themeGroup {\n  /* margin-bottom: 25px; */\n  padding-bottom: 15px;\n  /* border-bottom: 1px solid #f0f0f0; */\n  width: 100%;\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  border-radius: 8px;\n  background-color: #e6edff;\n  border: 1px solid #a3bdff;\n}\n\n/* .themeGroup:last-child {\n  border-bottom: none;\n} */\n\n.themeOuterWrapper {\n  /* border: 1px solid #ccc; */\n  width: 100%;\n  /* padding: 20px; */\n  border-radius: 8px;\n  /* margin: 20px auto; */\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 20px;\n}\n.themeinnerWrapper {\n  display: flex;\n  gap: 16px;\n  /* flex-wrap: wrap; */\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.themeGroup h4 {\n  margin-bottom: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #444;\n}\n\n.themeRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.themeRow label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #555;\n  margin-right: 12px;\n  flex: 1;\n}\n\n.themeRow input[type=\"color\"] {\n  width: 48px;\n  height: 32px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  background: none;\n  flex-shrink: 0;\n}\n\n.selectInput,\n.textInput {\n  width: 100%;\n  padding: 10px 14px;\n  font-size: 14px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #eff3ff;\n  transition:\n    border 0.2s ease,\n    background-color 0.2s ease;\n}\n\n.selectInput:focus,\n.textInput:focus {\n  border-color: #7b61ff;\n  background-color: #fff;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(123, 97, 255, 0.15);\n}\n\n.errorText {\n  color: #d93025;\n  font-size: 13px;\n  margin-top: 6px;\n  font-weight: 500;\n}\n\n@media (max-width: 1086px) and (min-width: 768px) {\n}\n\n@media (max-width: 768px) and (min-width: 468px) {\n  .themeOuterWrapper {\n    padding: 0px;\n    border: none;\n  }\n  .themeinnerWrapper {\n    display: block;\n  }\n  .themeinnerWrapper > :first-child {\n    margin-bottom: 20px;\n  }\n}\n\n@media (max-width: 467px) {\n  .themeOuterWrapper {\n    padding: 0px;\n    border: none;\n  }\n  .themeinnerWrapper {\n    display: block;\n  }\n  .themeinnerWrapper > :first-child {\n    margin-bottom: 20px;\n  }\n  .themeinnerWrapper > :last-child {\n    margin-top: 20px;\n  }\n  .themeCustomizer,\n  .themeGroup {\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"themeCustomizer": `ThemeCustomizer_themeCustomizer__PxPLJ`,
	"themeGroup": `ThemeCustomizer_themeGroup__X7Mzz`,
	"themeOuterWrapper": `ThemeCustomizer_themeOuterWrapper__YkH3g`,
	"themeinnerWrapper": `ThemeCustomizer_themeinnerWrapper__O6ws5`,
	"themeRow": `ThemeCustomizer_themeRow__EFayW`,
	"selectInput": `ThemeCustomizer_selectInput__aMWuS`,
	"textInput": `ThemeCustomizer_textInput__o0wXU`,
	"errorText": `ThemeCustomizer_errorText__SQtv-`
};
export default ___CSS_LOADER_EXPORT___;
